const getFAQSchema = (faqs: any = []) => {
  if (!faqs.length) {
    return [];
  }
  const faqData = [
    faqs.map((faq: any) => ({
      "@type": "Question",
      name: faq?.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq?.answer,
      },
    })),
  ];
  const schemaScript = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqData,
  };
  return [schemaScript];
};

export default getFAQSchema;
